import { Component, OnInit } from '@angular/core';

@Component({
    selector: 're-primary-footer',
    templateUrl: './primary-footer.component.html',
    styleUrls: ['./primary-footer.component.scss'],
    standalone: false
})
export class PrimaryFooterComponent implements OnInit {
  currentDate = new Date();
  copyrightYear = this.currentDate.getFullYear();
  constructor() { }

  ngOnInit() {
  }

}
